// Herramientas (modos) de SmartDx según los permisos del médico. Es la ÚNICA lista: la usa la
// DxNavbar (menú "Herramientas", con sus íconos) y la home v4, que la recibe por postMessage desde
// Home.js para armar el panel de su barra (#1439). Si se agrega un modo, se agrega acá.
export const HERRAMIENTAS = [
  { label: "Modo Diagnóstico", short: "Diagnóstico", path: "/raw-query", flag: "can_access_raw_query" },
  { label: "Modo Complicaciones", short: "Complicaciones", path: "/complicaciones", flag: "can_access_complicaciones" },
  { label: "Modo Transcriptor", short: "Transcriptor", path: "/transcriptor", flag: "can_access_transcriptor" },
  { label: "Modo Turno", short: "Turno", path: "/turno", flag: "can_access_turno" },
  { label: "Modo Informes", short: "Informes", path: "/informes", flag: "can_access_ingreso_epicrisis" },
  { label: "Epicrisis Radioterapia", short: "Epicrisis", sub: "Radioterapia", path: "/epicrisis-radonc", flag: "can_access_epicrisis_radonc" },
  { label: "Finder", short: "Finder", path: "/finder", flag: "can_access_finder" },
  { label: "Visualizador de Examenes", short: "Visualizador", sub: "de exámenes", path: "/visualizador-examenes", flag: "can_access_visualizador_examenes" },
  { label: "Recetas Ambulatorias", short: "Recetas", sub: "ambulatorias", path: "/recetas-ambulatorias", flag: "can_access_indicaciones_ambulatorias" },
  { label: "Histórico de recetas", short: "Histórico", sub: "de recetas", path: "/recetas-ambulatorias/historial", flag: "can_access_indicaciones_ambulatorias" },
];

export const herramientasDe = (user) =>
  HERRAMIENTAS.filter((h) => Boolean(user?.is_superuser) || Boolean(user?.[h.flag]));

// #1681 D10/D58: /perfil y Ajustes nombran los módulos con esta misma lista (una sola). Un permiso
// con dos entradas (recetas e histórico) sale una vez, con la primera etiqueta. Solo los encendidos.
export const modulosEncendidos = (user) => {
  const vistos = new Set();
  return HERRAMIENTAS.filter((h) => {
    if (!user?.[h.flag] || vistos.has(h.flag)) return false;
    vistos.add(h.flag);
    return true;
  });
};

// Nombre visible e iniciales, con la misma regla que la DxNavbar.
export const nombreVisible = (user) =>
  user?.professional_profile?.full_name || user?.username || user?.email || "";
export const iniciales = (nombre) =>
  (nombre || "?").trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");
